<template>
	<div>
		<RadioGroup
			v-model="selection"
			:options="options"
			@input="emitChangeEvent"
		/>
	</div>
</template>

<script>
import RadioGroup from "@/vue/common/form/RadioGroup";
import * as Helper from "@/helper/application/PrivateVehicleCompanyUsage";

export default {

	components: {
		RadioGroup
	},

	props: {
		value: {
			type: Boolean,
			required: false,
			default: undefined,
		},
	},

	data ()
	{
		return {
			selection: this.value,
		};
	},

	computed: {
		options ()
		{
			return [
				{value: Helper.IRRELEVANT, text: Helper.getLabel(Helper.IRRELEVANT)},
				{value: Helper.YES, text: Helper.getLabel(Helper.YES)},
				{value: Helper.NO, text: Helper.getLabel(Helper.NO)},
			]
		},
		valid ()
		{
			return this.selection !== undefined;
		}
	},

	methods: {
		emitChangeEvent ()
		{
			if (!this.valid)
			{
				this.$emit('input', undefined);
				return;
			}

			this.$emit('input', this.selection);
		}
	}
}
</script>
